<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
        <el-row>
          <el-col :span="24" class="label-val">
            <span class="label">改派订单：</span>
            <span class="value color1269FF">{{ detail.orderNo }}</span>
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">调度信息：</span>
            <span class="value"
              >{{ detail.dispatcherName }}（{{ detail.dispatcherPhone }}）</span
            >
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">原承运信息：</span>
            <span class="value"
              >{{ detail.oldDriverCarNumber }} | {{ detail.oldDriverName }}（{{
                detail.oldDriverPhone || "-"
              }}）</span
            >
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">改派后承运信息：</span>
            <span class="value"
              >{{ detail.newDriverCarNumber }} | {{ detail.newDriverName }}（{{
                detail.newDriverPhone || "-"
              }}）</span
            >
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">改派原因：</span>
            <span class="value">{{ detail.msg || "-" }}</span>
          </el-col>
          <el-col :span="24" class="label-val">
            <span class="label">发起时间：</span>
            <span class="value">{{ detail.reassignTime || "-" }}</span>
          </el-col>
        </el-row>
        <div class="title-box">
          <el-image :src="cheImage" class="title-label"></el-image>审批结果
        </div>
        <div class="examine2-box" v-if="isDetail">
          <div class="list">
            <span class="label">审批结果：</span>
            <span class="value">{{
              getLocalLabel("auditStatus", detail.auditStatus)
            }}</span>
          </div>
          <div class="list">
            <span class="label">操作人：</span>
            <span class="value">{{ detail.auditUserName || "-" }}</span>
          </div>
          <div class="list">
            <span class="label">操作时间：</span>
            <span class="value">{{ detail.auditTime || "-" }}</span>
          </div>
          <div class="list">
            <span class="label">备注：</span>
            <span class="value">{{ detail.auditMsg || "-" }}</span>
          </div>
        </div>
        <el-row :gutter="20" v-else>
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-col :span="24">
              <el-form-item prop="pass">
                <el-radio-group v-model="form.pass">
                  <el-radio :label="true">同意</el-radio>
                  <el-radio :label="false">不同意</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="auditMsg">
                <el-input
                  type="textarea"
                  clearable
                  rows="5"
                  placeholder="请输入备注"
                  v-model="form.auditMsg"
                  show-word-limit
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import { reassignAudit, setReal } from "./api";
import { getLocalLabel } from "@/utils/localDict";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "30%",
        show: false,
        title: "修改客户归属",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      isDetail: false,
      detail: {},
      form: { pass: true, auditMsg: "", reassignId: "" },
      rules: {
        auditMsg: [{ required: true, message: "备注不能为空" }],
        // realPhone: [{ required: true, message: "设备位置信息不能为空" }],
      },
    };
  },
  mounted() {},
  methods: {
    getLocalLabel,
    init(title, isDetail, row) {
      if (isDetail) {
        this.dialogObj.confirmFn = null;
      } else {
        this.dialogObj.confirmFn = this.submitForm;
      }
      this.dialogObj.title = title;
      this.isDetail = isDetail;
      if (!!row) {
        this.detail = Object.assign({}, row);
        this.form.reassignId = row.reassignId;
      }
      this.dialogObj.show = true;
    },

    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const par = {
            reassignId: this.form.reassignId,
            pass: this.form.pass,
            auditMsg: this.form.auditMsg,
          };
          reassignAudit(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("审批成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
  }
  .title-box {
    padding: 0.1rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .examine2-box {
    background-color: #f7fbff;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-top: 0.1rem;
    .list {
      line-height: 0.2rem;
    }
  }
}
</style>
